import { ReactElement, useEffect, useState } from 'react'
import {
  FlexWrapper,
  PageWrapper,
  SectionTitle,
  FileUploader,
  TostMessage,
  Loader,
  TableWrapper,
  TableHeader,
  TableFooter
} from '../../../../../components'
import UserFilterSection from '../../UserFilterSection'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
import { RootState } from '../../../../../redux/store'
import {
  getBatchDropdown,
  getBranchDropDown,
  getInstituteDropdown,
  getSelectedBatch,
  getSelectedBranch,
  getSelectedInstitute
} from '../../helpers'
import AdminType from '../../../../../const/admin'
import {
  getBatches,
  getBranches,
  getInstitutes
} from '../../../../../redux/coachingCenter/actions'
import strings from '../../../../../locale/en'
import { ROLE } from '../../../../../helpers/determineMenu'
import {
  getUploadedFiles,
  updateHasError,
  uploadBulkEntry
} from '../../../../../redux/user/actions'
import { Table } from 'react-bootstrap'
import { TableRow } from '../../subcomponents'
import { tableHeader } from './const'
import { DropdownListProps } from '../../../../../components/EditableDropdown/typings'

const BulkEntry = (): ReactElement => {
  const {
    institutes = [],
    branches = [],
    batches = [],
    selectedCoachingCentreId = '',
    selectedBranchId = '',
    selectedBatchId = '',
    role,
    loggedInUserId = '',
    hasError = false,
    isLoading,
    uploadedFiles = [],
    firstName = '',
    currentPage = 0,
    pageSize = 0,
    userDetail
  } = useSelector(
    (state: RootState) => ({
      institutes: state.coachingCenter.institutes,
      branches: state.coachingCenter.branches,
      batches: state.coachingCenter.batches,
      selectedCoachingCentreId: state.coachingCenter?.admin?.coachingCentreId,
      selectedBranchId: state.coachingCenter?.admin?.branchId,
      selectedBatchId: state.coachingCenter?.admin?.batchId,
      role: state.user.userInfo?.role,
      loggedInUserId: state.user.userInfo?.userDetail.coachingCenterId,
      hasError: state.user.hasError,
      isLoading: state.user.isLoading,
      uploadedFiles: state.user.uploadedFiles.fileList,
      firstName: state.user.userInfo?.userDetail.firstName,
      currentPage: state.user.uploadedFiles.currentPage + 1,
      pageSize: state.user.uploadedFiles.pageSize,
      userDetail: state.user?.userInfo?.userDetail
    }),
    shallowEqual
  )
  const dispatch = useDispatch()
  const [instituteName, setInstituteName] = useState('')
  const [branchName, setBranchName] = useState('')
  const [batchName, setBatchName] = useState<any>('')
  const [showValidationError, setShowValidationError] = useState(false)
  const defaultBranchId = userDetail?.branchIds?.length
    ? userDetail?.branchIds[0]
    : selectedBranchId
  const defaultInstituteId =
    userDetail?.coachingCenterId || selectedCoachingCentreId

  const institutesDropdown =
    role === ROLE.INSTITUTE_ADMIN
      ? [getSelectedInstitute(institutes, loggedInUserId)]
      : getInstituteDropdown(institutes)

  const branchDropdown = getBranchDropDown(branches)
  const batchDropdown = getBatchDropdown(batches)
  const selectedInstitute = getSelectedInstitute(
    institutes,
    selectedCoachingCentreId
  )
  const selectedBranch = getSelectedBranch(branches, selectedBranchId)
  const selectedBatch = getSelectedBatch(batches, selectedBatchId)
  const {
    menu: {
      admin: { bulkEntry },
      bulkEntry: { uploadError, selectBranchError }
    }
  } = strings

  const resetData = () => {
    setInstituteName('')
    setBranchName('')
    setBatchName('')
  }

  useEffect(() => {
    if (role === ROLE.BRANCH_ADMIN) {
      dispatch(
        getBatches({
          coachingCentreId: defaultInstituteId,
          branchId: defaultBranchId,
          type: AdminType.STUDENT
        })
      )
    } else if (role === ROLE.INSTITUTE_ADMIN) {
      dispatch(
        getBranches({
          coachingCentreId: defaultInstituteId,
          type: AdminType.STUDENT
        })
      )
    } else {
      if (!institutes.length) {
        dispatch(getInstitutes())
      }
    }

    dispatch(getUploadedFiles('1'))

    return () => {
      resetData()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <PageWrapper id="container">
      <FlexWrapper justifyContent="space-between" hasBorder>
        <SectionTitle title={bulkEntry} />
      </FlexWrapper>
      <TostMessage
        show={hasError || showValidationError}
        onCloseHandler={() => {
          setShowValidationError(false)
          dispatch(updateHasError(false))
        }}
        message={hasError ? uploadError : selectBranchError}
      />
      <UserFilterSection
        role={role}
        institueList={institutesDropdown}
        batchList={batchDropdown}
        branchList={branchDropdown}
        instituteValue={selectedInstitute}
        branchValue={selectedBranch}
        batchValue={selectedBatch}
        handleBatchSelect={(batchs: any) => {
          const batch = batchs.map((value: DropdownListProps) => value?.id)
          setBatchName(batch)
        }}
        handleBranchSelect={(branchs: any) => {
          const branch = branchs.map((value: DropdownListProps) => value?.id)
          dispatch(
            getBatches({
              coachingCentreId: instituteName || loggedInUserId,
              branchId: branch,
              type: AdminType.STUDENT
            })
          )
          setBranchName(branch)
        }}
        handleinstituteSelect={(institue) => {
          dispatch(
            getBranches({
              coachingCentreId: institue?.id,
              type: AdminType.STUDENT
            })
          )
          setInstituteName(institue?.id)
        }}
      />
      <FileUploader
        type="doc"
        onUploadSuccess={(file) => {
          const coachingId = instituteName || defaultInstituteId
          const branchId = branchName || defaultBranchId
          if (coachingId && branchId) {
            dispatch(
              uploadBulkEntry({
                instituteId: coachingId,
                branchId: branchId,
                batchId: batchName,
                file
              })
            )
            resetData()
          } else {
            setShowValidationError(true)
          }
        }}
      />
      {isLoading ? (
        <Loader />
      ) : (
        <div>
          <TableWrapper>
            <Table size="sm" responsive="sm">
              <TableHeader>
                <TableRow>
                  {tableHeader?.map((header, index) => (
                    <th key={`bulk-entry-${index}`}>{header}</th>
                  ))}
                </TableRow>
              </TableHeader>
              <tbody>
                {uploadedFiles?.map((file, index) => {
                  const { fileName, status, uploadedOn } = file
                  return (
                    <TableRow key={`file-list-${index}`}>
                      <td>{fileName}</td>
                      <td>{firstName}</td>
                      <td>{uploadedOn}</td>
                      <td>{status}</td>
                    </TableRow>
                  )
                })}
              </tbody>
            </Table>
            <TableFooter
              currentPage={currentPage}
              totalPages={pageSize}
              handleNext={() => {
                dispatch(getUploadedFiles(`${currentPage + 1}`))
              }}
              handlePrevious={() => {
                dispatch(getUploadedFiles(`${currentPage - 1}`))
              }}
            />
          </TableWrapper>
        </div>
      )}
    </PageWrapper>
  )
}

export default BulkEntry
